import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const MAINTENANCE_KEY = 'siteOffline';
const SECRET = 'protectwebsite';

const urlParams = new URLSearchParams(window.location.search);
const shutdownKey = urlParams.get('shutdown');
const onlineKey = urlParams.get('online');

if (shutdownKey === SECRET) {
  localStorage.setItem(MAINTENANCE_KEY, 'true');
}

if (onlineKey === SECRET) {
  localStorage.setItem(MAINTENANCE_KEY, 'false');
}

const checkMaintenance = () => {
  const offline = localStorage.getItem(MAINTENANCE_KEY) === 'true';
  if (offline) {
    const root = document.getElementById('root');
    root.innerHTML = `
      <div style="text-align:center; margin-top:50px; font-family:Arial, sans-serif;">
        <h1>Website is temporarily down for maintenance</h1>
        <p>Please check back later.</p>
      </div>
    `;
    return true;
  }
  return false;
};

if (!checkMaintenance()) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();